// extracted by mini-css-extract-plugin
export default {"loginLayout":"baselogin_loginLayout__+EkLp","headers":"baselogin_headers__RxVPt"};